import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.25 3.608c-1.072.156-1.833 1.017-1.833 1.975v11.385q.067-.02.135-.038c.293-.116.613-.18.948-.18h12.083V3.833a.25.25 0 0 0-.25-.25H12.75V11a.75.75 0 0 1-1.219.586L10 10.36l-1.531 1.226A.75.75 0 0 1 7.25 11zM3.917 5.583v13.75A2.583 2.583 0 0 0 6.5 21.917h11.833a1.75 1.75 0 0 0 1.75-1.75V18.5q0-.128-.017-.25h.017V3.833a1.75 1.75 0 0 0-1.75-1.75H7.6c-1.988 0-3.683 1.522-3.683 3.5M6.27 18.315a3 3 0 0 0-.242.042 1.083 1.083 0 0 0 .47 2.06h11.834a.25.25 0 0 0 .25-.25V18.5a.25.25 0 0 0-.25-.25H7.477a9.5 9.5 0 0 0-1.206.065M8.75 9.44V3.75h2.5v5.69l-.781-.626a.75.75 0 0 0-.938 0z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }